(() => {
  const current = new URL(location.href);
  if (/\/pages\/wisconsin-hub\/?$/.test(current.pathname) && !current.searchParams.has('view')) {
    const hash = current.hash;
    let view = '';
    if (/^#(guide-|field-notes|wisconsin-guides|hub-planning|hub-outdoors|wisco-events|have-your-say|saved-gear|wisco-merch|hub-signup)/.test(hash) || ['gear','mine','region','interest','q','saved'].some(key => current.searchParams.has(key))) view = 'community';
    else if (/^#(wisco-tools|wisco-compare|wisco-create)$/.test(hash)) view = 'gear';
    else if (/^#(wisco-play|wisco-bingo)$/.test(hash)) view = 'games';
    else if (/^#(wisco-tool-shed|wisco-humor)$/.test(hash)) view = 'tools';
    else if (hash === '#wisco-trail-desk') view = 'trails';
    if (view) { current.searchParams.set('view', 'wisco-' + view); location.replace(current.href); return; }
  }
  const preservePreview = (scope = document) => {
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (!preview) return;
    scope.querySelectorAll('a[data-wisco-route]').forEach(link => {
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin) { url.searchParams.set('preview_theme_id', preview); link.href = url.href; }
    });
  };
  const initialize = (scope = document) => {
    preservePreview(scope);
    scope.querySelectorAll('[data-wisco-labs]').forEach(root => {
      if (root.dataset.roomsReady) return;
      root.dataset.roomsReady = 'true';
      const tabs = [...root.querySelectorAll('[data-tool-tab]')];
      const panels = [...root.querySelectorAll('[data-tool-panel]')];
      const allowed = ['deer', 'fish', 'fun'];
      const select = (tool, navigate = false, focus = false) => {
        const selected = allowed.includes(tool) ? tool : 'fish';
        tabs.forEach(tab => {
          const active = tab.dataset.toolTab === selected;
          tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        panels.forEach(panel => {
          panel.hidden = panel.dataset.toolPanel !== selected; panel.open = !panel.hidden;
          panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', 'tool-tab-' + panel.dataset.toolPanel);
        });
        if (navigate) { const url = new URL(location.href); url.searchParams.set('tool', selected); history.pushState({}, '', url); }
      };
      root.querySelector('[data-tool-selector]').hidden = false;
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab.dataset.toolTab, true));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(tabs[next].dataset.toolTab, true, true); }
        });
      });
      panels.forEach(panel => {
        const kind = panel.dataset.toolPanel;
        const result = panel.querySelector(`[data-${kind}-output]`);
        const empty = panel.querySelector('[data-empty-result]');
        const sync = () => { empty.hidden = !result.hidden; panel.classList.toggle('b10-has-result', !result.hidden); };
        new MutationObserver(sync).observe(result, { attributes: true, attributeFilter: ['hidden'] }); sync();
      });
      select(new URLSearchParams(location.search).get('tool'));
      window.addEventListener('popstate', () => select(new URLSearchParams(location.search).get('tool')));
    });
  };
  initialize();
  if (!window.wiscoBoard10Listener) {
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    window.wiscoBoard10Listener = true;
  }
})();
